import { render } from "./FormListLocation.vue?vue&type=template&id=2d2fa387"
import script from "./FormListLocation.vue?vue&type=script&lang=js"
export * from "./FormListLocation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormListLocation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d2fa387"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d2fa387', __exports__)) {
    console.log('reload')
    api.reload('2d2fa387', __exports__)
  }
  
  module.hot.accept("./FormListLocation.vue?vue&type=template&id=2d2fa387", () => {
    console.log('re-render')
    api.rerender('2d2fa387', render)
  })

}


export default __exports__